import { initContract } from "@ts-rest/core";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    ListMcpConnectionsResponseSchema,
    McpConnectionIdPathParamsSchema,
} from "../schemas/domains/mcp/mcp-connection.schema";

const c = initContract();

export const mcpConnectionContract = c.router(
    {
        list: {
            method: "GET",
            path: "",
            responses: {
                200: ListMcpConnectionsResponseSchema,
                401: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        revoke: {
            method: "DELETE",
            path: "/:id",
            pathParams: McpConnectionIdPathParamsSchema,
            body: c.noBody(),
            responses: {
                200: c.noBody(),
                401: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/mcp-connections",
    },
);
